export default class Account {
    constructor(account, rates) {
        Object.assign(this, account)

        this.rates = rates
    }

    priceMonthly() {
        return {
            usd: this.base_price / 100,
            rsd: this.base_price / 100 * this.rates.rsd
        }
    }

    priceAnnualy() {
        return {
            usd: this.annual_price / 100,
            rsd: this.annual_price / 100 * this.rates.rsd
        }
    }

    getSubscriptionType(opt) {
        const type = this.type.toUpperCase()

        return `${this.type}-${opt}`
    }

    supportDescription() {
        if (this.support_type == 'email') {
            return 'accountSupportEmailDescription'
        }

        if (this.support_type == 'standard') {
            return 'accountSupportStandardDescription'
        }

        if (this.support_type == 'premium') {
            return 'accountSupportPremiumDescription'
        }
    }
} 